/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ContactSearchResultDto;
(function (ContactSearchResultDto) {
    let ats;
    (function (ats) {
        ats["LEVER"] = "Lever";
        ats["GREENHOUSE"] = "Greenhouse";
        ats["ASHBY"] = "Ashby";
        ats["RECRUITERFLOW"] = "Recruiterflow";
        ats["CLOCKWORK"] = "Clockwork";
        ats["BULLHORN"] = "Bullhorn";
        ats["ORACLE_TALEO"] = "Oracle Taleo";
        ats["WORKDAY"] = "Workday";
    })(ats = ContactSearchResultDto.ats || (ContactSearchResultDto.ats = {}));
})(ContactSearchResultDto || (ContactSearchResultDto = {}));
